<template>
  <login-content
    id-type="teacher"
    id-placeholder="Email"
    id-name="email"
    id-icon="user-tie"
    password-name="teacher_password"
    register-title="請輸入您的信箱"
    forget-password-title="忘記密碼？請輸入您的信箱"
    @login:submitted="teacherLogin"
    @signup:submitted="teacherSignUp"
    @password:forget="teacherForgetPassword"
  >
    <input-group>
      <form-input
        v-model="email"
        type="email"
        placeholder="Email"
      />
    </input-group>
  </login-content>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import InputGroup from '~components/common/form/input/Group'
import FormInput from '~components/common/form/input'
import LoginContent from '~components/pages/login/LoginContent'

export default {
  name: 'EnterpriseLoginContent',
  components: {
    LoginContent,
    InputGroup,
    FormInput
  },
  computed: {
    ...mapGetters('pages/teachers', [
      'currentTeacherReminderGetter',
    ]),
  },
  data () {
    return {
      email: '',
    }
  },
  methods: {
    ...mapActions('auth', [
      'userLogin',
      'userSignUp',
      'userForgetPassword',
    ]),
    ...mapActions('layouts', [
      'newToast',
    ]),
    ...mapActions('pages/teachers', [
      'getTeacherReminder',
    ]),
    async teacherLogin (data) {
      await this.userLogin({
        type: 'teacher',
        data
      });
      await this.getTeacherReminder();
      [...this.currentTeacherReminderGetter].forEach(toast => {
        this.newToast({
          variant: toast.alert_type,
          title: '提醒你',
          message: toast.message,
        });
      });
    },
    teacherSignUp () {
      /*this.userSignUp({
        type: 'teacher',
        account: this.email
      })*/
    },
    teacherForgetPassword () {
      /*this.userForgetPassword({
        type: 'teacher',
        account: this.email
      })*/
    },
  }
}
</script>
